import React, { useState } from 'react'
import { callShinhanAuthRequest, callShinhanAuthResult } from '../../../api/auth/shinhan'

const STEP = {
  INPUT: 'INPUT',
  WAITING: 'WAITING',
}

// mode: 'join' | 'dormant' | 'normal'
const ShinhanModal = ({ mode = 'join', onClose, onComplete }) => {
  const [step, setStep] = useState(STEP.INPUT)
  const [userName, setUserName] = useState('')
  const [userBirth, setUserBirth] = useState('')
  const [userHpNo, setUserHpNo] = useState('')
  const [termsAgreed, setTermsAgreed] = useState(false)
  const [termsModalOpen, setTermsModalOpen] = useState(false)
  const [signTxId, setSignTxId] = useState(null)
  const [certTxId, setCertTxId] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')

  const requestAuth = async () => {
    setIsLoading(true)
    setErrorMsg('')
    const result = await callShinhanAuthRequest({ userName, userBirth, userHpNo })
    setIsLoading(false)

    if (result.success) {
      setSignTxId(result.data.signTxId)
      setCertTxId(result.data.certTxId)
      setStep(STEP.WAITING)
    } else {
      setErrorMsg(result.message)
    }
  }

  const handleRequestAuth = () => {
    requestAuth()
  }

  const handleResend = () => {
    setSignTxId(null)
    setCertTxId(null)
    requestAuth()
  }

  const handleComplete = async () => {
    if (!signTxId || !certTxId) return

    setIsLoading(true)
    setErrorMsg('')
    const result = await callShinhanAuthResult({ signTxId, certTxId })
    setIsLoading(false)

    if (result.success) {
      if (onComplete) {
        onComplete(result.data, signTxId)
      }
    } else {
      setErrorMsg(result.message)
    }
  }

  const isFormValid = userName.trim().length > 0
    && userBirth.trim().length === 8
    && userHpNo.trim().length >= 10
    && termsAgreed

  return (
    <div className='shinhan_modal_overlay'>
      <div className='shinhan_modal'>
        {/* 헤더 */}
        <div className='shinhan_modal_header'>
          <div className='shinhan_modal_header_spacer'></div>
          <span className='shinhan_modal_title'>신한인증서</span>
          <button type='button' className='shinhan_modal_close' onClick={onClose}>
            <img src='/v2/imgs/shinhan/ico-shinhan-close.png' alt='닫기' />
          </button>
        </div>

        {step === STEP.INPUT ? (
          <div className='shinhan_modal_body'>
            {/* 입력 폼 */}
            <div className='shinhan_input_group'>
              <label className='shinhan_label'>내 정보 입력</label>
              <input
                type='text'
                className='shinhan_input'
                placeholder='한글 또는 영문으로 입력해주세요.'
                value={userName}
                onChange={e => setUserName(e.target.value)}
              />
            </div>
            <div className='shinhan_input_group'>
              <label className='shinhan_label'>생년월일</label>
              <input
                type='text'
                className='shinhan_input'
                placeholder='8자리로 입력해주세요.'
                maxLength={8}
                value={userBirth}
                onChange={e => setUserBirth(e.target.value.replace(/[^0-9]/g, ''))}
              />
            </div>
            <div className='shinhan_input_group'>
              <label className='shinhan_label'>휴대폰 번호</label>
              <input
                type='text'
                className='shinhan_input'
                placeholder='숫자만 입력해주세요.'
                maxLength={11}
                value={userHpNo}
                onChange={e => setUserHpNo(e.target.value.replace(/[^0-9]/g, ''))}
              />
            </div>

            {/* 이용약관 동의 */}
            <div className='shinhan_terms'>
              <h4 className='shinhan_terms_title'>이용약관 동의</h4>
              <div className='shinhan_terms_row'>
                <span className='shinhan_terms_label'>
                  제3자 정보제공 동의(필수)
                  <span className='shinhan_terms_arrow' onClick={() => setTermsModalOpen(true)}>
                    <img src='/v2/imgs/shinhan/ico-shinhan-right.png' alt='' />
                  </span>
                </span>
                <input
                  type='checkbox'
                  className='shinhan_terms_check'
                  checked={termsAgreed}
                  onChange={e => setTermsAgreed(e.target.checked)}
                />
              </div>
            </div>

            {errorMsg && <p className='shinhan_error_msg'>{errorMsg}</p>}

            {/* 인증 요청 버튼 */}
            <button
              type='button'
              className={'shinhan_btn_submit' + (isFormValid && !isLoading ? ' active' : '')}
              disabled={!isFormValid || isLoading}
              onClick={handleRequestAuth}
            >
              {isLoading ? '요청 중...' : '인증 요청'}
            </button>
          </div>
        ) : (
          <div className='shinhan_modal_body shinhan_waiting'>
            {/* 인증 대기 화면 */}
            <div className='shinhan_waiting_content'>
              <div className='shinhan_sol_icon'>
                <img src='/v2/imgs/shinhan/ico-shinhan-logo.png' alt='신한인증서' width='44' height='44' />
              </div>
              <h3 className='shinhan_waiting_title'>인증을 진행해주세요.</h3>
              <p className='shinhan_waiting_desc'>
                푸시(인증요청)가 오지 않았다면
                <br />
                아래 내용을 확인해주세요.
                <br />
                ① 신한SOL뱅크앱 설치 확인
                <br />
                ② 사용자정보(이름, 생년월일, 휴대폰번호) 확인
              </p>
            </div>

            {errorMsg && <p className='shinhan_error_msg'>{errorMsg}</p>}

            <div className='shinhan_btn_wrap'>
              <button
                type='button'
                className='shinhan_btn_resend'
                onClick={handleResend}
                disabled={isLoading}
              >
                재전송
              </button>
              <button
                type='button'
                className='shinhan_btn_complete'
                onClick={handleComplete}
                disabled={isLoading}
              >
                {isLoading ? '확인 중...' : '인증 완료'}
              </button>
            </div>
          </div>
        )}
      </div>

      {/* 제3자 정보제공 동의 내부 모달 */}
      {termsModalOpen && (
        <div className='shinhan_terms_modal_overlay'>
          <div className='shinhan_terms_modal'>
            <div className='shinhan_terms_modal_header'>
              개인정보 제 3자 제공에 대한 안내
            </div>
            <div className='shinhan_terms_modal_body'>
              <p>A. 제3자는 당해 서비스를 제공하는 사업자·개인정보업무수탁자·영업양수인과 그 서비스를 이용하고 있는 정보 주체 이외의 모든 자연인과 법인을 의미하며, kt야구단의 경우에는 제휴계약을 맺은 사업자입니다.</p>
              <p>B. 개인정보를 제3자에게 제공하려면 제공받는 자, 제공받는 자의 개인정보 이용목적, 제공하는 개인정보 항목, 제공받는 자의 개인정보 보유 및 이용기간 등을 충분하게 알리고 동의를 얻어야 합니다.</p>
              <p>C. 사업자로부터 정보 주체의 개인정보를 제공받은 자는 정보 주체의 별도의 동의가 있거나 다른 법률에 특별한 규정이 있는 경우를 제외하고 개인정보를 제공받은 목적과 다른 용도로 이용하거나 제3자에게 제공하지 않습니다.</p>
              <h5>(주)신한은행</h5>
              <p>1. 항목 : 이름, 생년월일, 휴대전화번호</p>
              <p>2. 제공목적 : 신한SIGN (본인확인, 전자서명인증) 서비스 제공</p>
            </div>
            <div className='shinhan_terms_modal_footer'>
              <button type='button' className='shinhan_terms_modal_btn' onClick={() => setTermsModalOpen(false)}>
                확인
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ShinhanModal
